import React, { Suspense, lazy } from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import './index.css';
import './chart.css';
import './step.css';

import Nav from './layouts/nav';
import Footer from './layouts/Footer';

const Home = lazy(() => import('./components/Dashboard/Home'));
const ScrollToTop = lazy(() => import('./layouts/ScrollToTop'));
const AcessSettings = lazy(() => import('./pages/AccessSettings/manageAccessSettings'));
const TransactionSettings = lazy(() => import('./pages/TransactionSettings/transaction-settings'));
const MerchantSettings = lazy(() => import('./pages/MerchantSettings/merchant-settings'));
const AddKYC = lazy(() => import('./pages/KycList/addUpdateKyc'));
const Profile = lazy(() => import('./pages/Profile/update-profile'));
const KycList = lazy(() => import('./pages/KycList/manageKYC'));
const AddMerchants = lazy(() => import('./pages/MerchantList/add-merchants'));
const EditMerchants = lazy(() => import('./pages/MerchantList/edit-merchants'));
const MerchantDashboard = lazy(() => import('./pages/MerchantList/merchant-danhboard'));
const Merchants = lazy(() => import('./pages/MerchantList/manage-merchant-list'));
const ViewMerchantData = lazy(() => import('./pages/MerchantList/ViewMerchantData'));
const AddMerchantBankAccounts = lazy(() => import('./pages/MerchantBankAccounts/add-bank-accounts'));
const MerchantBankAccounts = lazy(() => import('./pages/MerchantBankAccounts/merchants-bank-list'));
const UpdateMerchantSettings = lazy(() => import('./pages/MerchantsTransactionSettings/update-merchants-transaction-settings'));
const ListMerchantSettings = lazy(() => import('./pages/MerchantsTransactionSettings/merchants-transaction-settings-list'));
const UpdateMerchantKYC = lazy(() => import('./pages/MerchantKYC/update-merchants-kyc'));
const ManageMerchantKYC = lazy(() => import('./pages/MerchantKYC/manage-merchants-kyc'));
const UpdateIPAddress = lazy(() => import('../jsx/pages/MerchantsIpAddress/addUpdateIP'));
const ManageIPAddress = lazy(() => import('./pages/MerchantsIpAddress/manageIP'));
const UpdateFundRequests = lazy(() => import('../jsx/pages/MerchantFundRequests/addUpdateFundRequests'));
const ManageFundRequests = lazy(() => import('./pages/MerchantFundRequests/manageFundRequests'));
const AddUpdateDebitFundsRequests = lazy(() => import('../jsx/pages/MerchantDebitFunds/addUpdateDebitFundsRequests'));
const MerchantDebitFundsRequests = lazy(() => import('./pages/MerchantDebitFunds/merchantDebitFundsRequests'));
const MerchantPayouts = lazy(() => import('./pages/MerchantPayouts/manageMerchantPayouts'));
const ComplaintTransactions = lazy(() => import('./pages/MerchantPayouts/complaintTransactions'));
const ViewTransactions = lazy(() => import('./pages/MerchantPayouts/viewTransactions'));
const MerchantCollections = lazy(() => import('./pages/MerchantCollections/manageMerchantCollections'));
const MerchantFundReport = lazy(() => import('./pages/MerchantReports/manageMerchantFundReports'));
const MerchantPayoutReports = lazy(() => import('./pages/MerchantReports/manageMerchantPayoutReports'));
const MerchantInvoice = lazy(() => import('./pages/MerchantInvoice/manageMerchantInvoice'));
const ApplicationMessagesList = lazy(() => import('./pages/ApplicationMessages/application-messages-list'));
const AddApplicationMessage = lazy(() => import('./pages/ApplicationMessages/add-application-message'));
const ManageStatementFiles = lazy(() => import('./pages/ProcessStatement/manageStatementFiles'));
const UploadStatement = lazy(() => import('./pages/ProcessStatement/uploadStatement'));
const StatementRecords = lazy(() => import('./pages/ProcessStatement/statementRecords'));
const ReprocessLogs = lazy(() => import('./pages/ProcessStatement/reprocessLogs'));


const Markup = () => {
  const allroutes = [
    { url: '', component: <Home /> },
    { url: 'dashboard', component: <Home /> },
    { url: 'profile', component: <Profile /> },
    { url: 'access-key-settings', component: <AcessSettings /> },
    { url: 'transaction-settings', component: <TransactionSettings /> },
    { url: 'merchant-settings', component: <MerchantSettings /> },
    { url: 'kyc-settings/add-kyc', component: <AddKYC /> },
    { url: 'kyc-settings/edit-kyc/:id', component: <AddKYC /> },
    { url: 'kyc-settings', component: <KycList /> },
    { url: 'merchants/create', component: <AddMerchants /> },
    { url: 'merchants/edit-merchant/:id', component: <EditMerchants /> },
    { url: 'merchants/edit-merchant/:id/:tab', component: <EditMerchants /> },
    { url: 'merchants/view-merchant/:id', component: <MerchantDashboard /> },
    { url: 'merchants/view-settings-merchant/:id', component: <ViewMerchantData /> },
    { url: 'merchants', component: <Merchants /> },
    { url: 'merchants-bank-accounts/edit-merchant/:id', component: <AddMerchantBankAccounts /> },
    { url: 'merchants-bank-accounts', component: <MerchantBankAccounts /> },
    { url: 'merchant-transaction-settings/update-settings/:id', component: <UpdateMerchantSettings /> },
    { url: 'merchant-transaction-settings', component: <ListMerchantSettings /> },
    { url: 'merchants-kyc/update-kyc/:id', component: <UpdateMerchantKYC /> },
    { url: 'merchants-kyc', component: <ManageMerchantKYC /> },
    { url: 'ip-whitelisted/create', component: <UpdateIPAddress /> },
    { url: 'ip-whitelisted/update/:id', component: <UpdateIPAddress /> },
    { url: 'ip-whitelisted', component: <ManageIPAddress /> },
    { url: 'fund-requests/create', component: <UpdateFundRequests /> },
    { url: 'fund-requests/update/:id', component: <UpdateFundRequests /> },
    { url: 'fund-requests', component: <ManageFundRequests /> },
    { url: 'debit-funds/create', component: <AddUpdateDebitFundsRequests /> },
    { url: 'debit-funds/update/:id', component: <AddUpdateDebitFundsRequests /> },
    { url: 'debit-funds', component: <MerchantDebitFundsRequests /> },
    { url: 'transactions', component: <MerchantPayouts /> },
    { url: 'transactions/complaint/:id', component: <ComplaintTransactions /> },
    { url: 'transactions/view/:id', component: <ViewTransactions /> },
    { url: 'collections', component: <MerchantCollections /> },
    { url: 'reports/fund-requests', component: <MerchantFundReport /> },
    { url: 'reports/payout', component: <MerchantPayoutReports /> },
    { url: 'reports/merchant-invoices', component: <MerchantInvoice /> },
    { url: 'application-messages', component: <ApplicationMessagesList /> },
    { url: 'add-application-message', component: <AddApplicationMessage /> },
    { url: 'edit-application-message/:id', component: <AddApplicationMessage /> },
    { url: 'process-statement', component: <ManageStatementFiles /> },
    { url: 'process-statement/upload', component: <UploadStatement /> },
    { url: 'process-statement/records', component: <StatementRecords /> },
    { url: 'process-statement/reprocess-logs', component: <ReprocessLogs /> },
  ];

  return (
    <>
     <Routes>
    
    {/* Main Layout Route */}
    <Route element={<MainLayout />}>
      {allroutes.map((data, i) => (
        <Route
          key={i}
          path={data.url}
          element={
            <Suspense
              fallback={
                <div id="preloader">
                  <div className="sk-three-bounce">
                    <div className="sk-child sk-bounce1"></div>
                    <div className="sk-child sk-bounce2"></div>
                    <div className="sk-child sk-bounce3"></div>
                  </div>
                </div>
              }
            >
              {data.component}
              <ScrollToTop />
            </Suspense>
          }
        />
      ))}
    </Route>
  </Routes>
    </>
  );
};

function MainLayout() {
  return (
    <div id="main-wrapper" className="show">
      <Nav />
      <div className="content-body" style={{ minHeight: window.screen.height - 45 }}>
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Markup;